export default function AvatarDetailDoc ({ avatar }) {

    return(
        <div className="detail-sections-container styled-scrollbar">
            <iframe src={ avatar.data.docUrl } title={ avatar.data.name }/>
        </div>
    )
}